import { AxiosResponse } from "axios";
import { ApiBrave } from "../../Apis/Brave";
import objectToParams from "../../utils/objectToParams";
import {
  IColaboradorAtualizarForm,
  IColaboradorCompletoDTO,
  IColaboradorDTO,
  IColaboradorForm,
  IColaboradorGetProps,
  IListarAgendamentosProps,
  IlistarPorDeliveryProps,
  IlistarPorLojaProps,
  IPageColaboradorDTO,
} from "../../types/colaborador";
import { IAgendamentoDTO } from "../../types/agendamento";
import { removeEmpty } from "../../utils/removeEmpty";

const basePath = "/colaborador";

export class Colaborador {
  static async get(
    props?: IColaboradorGetProps
  ): Promise<AxiosResponse<IPageColaboradorDTO>> {
    let params = "";

    if (props) {
      const values = removeEmpty(props);
      params = new URLSearchParams(values).toString();
    }
    return ApiBrave.get(params ? `${basePath}?${params}` : basePath);
  }

  static async getById({
    uuid,
  }: {
    uuid: string;
  }): Promise<AxiosResponse<IColaboradorCompletoDTO>> {
    return ApiBrave.get(`${basePath}/${uuid}`);
  }

  static async atual(): Promise<AxiosResponse<IColaboradorCompletoDTO>> {
    return ApiBrave.get(`${basePath}/atual`);
  }

  static async listarAgendamentos(
    props: IListarAgendamentosProps
  ): Promise<AxiosResponse<IAgendamentoDTO[]>> {
    const params = objectToParams(props);
    return ApiBrave.get(`${basePath}/listar-agendamentos?${params}`);
  }

  static async listarPorDelivery(
    props: IlistarPorDeliveryProps
  ): Promise<AxiosResponse<IColaboradorDTO[]>> {
    const params = objectToParams(props);
    return ApiBrave.get(`${basePath}/listar-por-delivery?${params}`);
  }

  static async listarPorLoja(
    props: IlistarPorLojaProps
  ): Promise<AxiosResponse<IColaboradorDTO[]>> {
    const params = objectToParams(props);
    return ApiBrave.get(`${basePath}/listar-por-loja?${params}`);
  }

  static async post(
    props: IColaboradorForm
  ): Promise<AxiosResponse<IColaboradorForm>> {
    const data = removeEmpty(props);
    return ApiBrave.post(`${basePath}`, data);
  }

  static async atualizar(
    props: IColaboradorAtualizarForm
  ): Promise<AxiosResponse<IColaboradorCompletoDTO>> {
    const { uuid, ...rest } = props;
    return ApiBrave.put(`${basePath}/${uuid}/atualizar`, rest);
  }

  static async ativar({
    uuid,
  }: {
    uuid: string;
  }): Promise<AxiosResponse<IColaboradorCompletoDTO>> {
    return ApiBrave.put(`${basePath}/${uuid}/ativar`);
  }

  static async inativar({
    uuid,
  }: {
    uuid: string;
  }): Promise<AxiosResponse<IColaboradorCompletoDTO>> {
    return ApiBrave.put(`${basePath}/${uuid}/inativar`);
  }

  static async resetPassword({
    uuid,
  }: {
    uuid: string;
  }): Promise<AxiosResponse<string>> {
    return ApiBrave.put(`${basePath}/${uuid}/resetar-senha`);
  }
}
